import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Blog from '../views/Blog.vue'
import Post from '../views/Post.vue'

import Posts from '../assets/posts/posts.json'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
    children: Posts.posts.map(val => <RouteConfig>{
      path: val.file.substring(0, val.file.lastIndexOf('.')),
      props: {
        title: val.title,
        file: val.file
      },
      component: Post
    })
  }
]

const router = new VueRouter({
  routes
})

export default router
